import axios from 'axios';
import Helpers from 'utils/helpers';

async function getUserStore() {
  const url = `BackOfficeReports/UserStore`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getUserRuns(hierarchyId) {
  if (hierarchyId == null) return [];

  const url = `BackOfficeReports/UserRuns/${hierarchyId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getReportTypes() {
  const url = `BackOfficeReports/ReportTypes`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getReportConfigurations() {
  const url = `BackOfficeReports/ReportConfigurations`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getSiteReportConfigurations(hierarchyId) {
  if (hierarchyId == null) return [];

  const url = `BackOfficeReports/ReportConfigurations/${hierarchyId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function insertTaskForRun(taskId, task) {
  const url = taskId ? `BackOfficeReports/Task/Run/${taskId}` : `BackOfficeReports/Task/Run`;
  const request = {
    method: 'POST',
    url: url,
    data: task,
  };

  const res = await axios(request);
  return res.data;
}

async function insertTask(task) {
  const url = `BackOfficeReports/Task`;
  const request = {
    method: 'POST',
    url: url,
    data: task,
  };

  const res = await axios(request);
  return res.data;
}

async function updateTask(taskId, taskDetails) {
  if (taskDetails && taskDetails.scheduler && taskDetails.scheduler.startDateTime) {
    taskDetails.scheduler.startDateTime = Helpers.Date.toApiDateTimeObject(taskDetails.scheduler.startDateTime);
  }

  const url = `BackOfficeReports/Task/${taskId}`;
  const request = {
    method: 'PUT',
    url: url,
    data: taskDetails,
  };

  const res = await axios(request);
  return res.data;
}

async function disableTask(taskId) {
  const url = `BackOfficeReports/Task/${taskId}`;
  const request = {
    method: 'DELETE',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getTaskRuns({ taskId, pageOffset, pageSize, filters }) {
  filters = filters || {};
  filters.pageOffset = pageOffset;
  filters.pageSize = pageSize;

  const url = `BackOfficeReports/Task/${taskId}/Runs`;
  const request = {
    method: 'GET',
    url: url,
    params: filters,
  };

  const res = await axios(request);
  return res.data;
}

async function getTask(taskId) {
  const url = `BackOfficeReports/Task/${taskId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getTaskRunStatus(taskId, runId) {
  const url = `BackOfficeReports/Task/${taskId}/run/${runId}/details`;
  const request = {
    method: 'GET',
    url: url,
    headers: { background: 'true' },
  };

  const res = await axios(request);
  return res.data;
}

async function executeTaskNow(taskId) {
  const url = `BackOfficeReports/Task/Execute/${taskId}`;
  const request = {
    method: 'POST',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getStoreTasks(hierarchyId) {
  const url = `BackOfficeReports/TaskList/${hierarchyId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getRecipientsList() {
  const url = `BackOfficeReports/Recipients/List`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function insertRecipient(newRecipientFirstName, newRecipientLastName, newRecipientEmail) {
  const url = `BackOfficeReports/Recipients`;
  const request = {
    method: 'POST',
    url: url,
    data: {
      firstName: newRecipientFirstName,
      lastName: newRecipientLastName,
      email: newRecipientEmail,
    },
  };

  const res = await axios(request);
  return res.data;
}




const BackofficeReportsService = {
  API: {
    getUserStore,
    getUserRuns,
    getReportTypes,
    getReportConfigurations,
    getSiteReportConfigurations,
    insertTaskForRun,
    insertTask,
    updateTask,
    disableTask,
    getTask,
    getTaskRunStatus,
    executeTaskNow,
    getStoreTasks,
    getRecipientsList,
    insertRecipient,
    getTaskRuns
  }
};

export default BackofficeReportsService;